import { useFlags as useLDFlags, } from 'launchdarkly-react-client-sdk';
import { useContext } from 'react';
import { OverrideContext } from './FeatureFlagProvider';
export const useFlags = () => {
    const ldFlags = useLDFlags();
    const { overriddenFlags } = useContext(OverrideContext);
    return { ...ldFlags, ...overriddenFlags };
};
